import { Button, Form, notification } from "antd";
import PreviewInputs from "../../pages/preview-inputs/preview-inputs";
import QuestionPreview from "../../pages/questions/QuestionPreview";
import { templateAction } from "../../../actions/template-action";
import { useDispatch } from "react-redux";
import Thankyou from "../../pages/thank-you/thank-you";
import { useContext, useState } from "react";
import { TemplateContext2Provider } from "../../contexts/TemplateContext2";

export default function QuestionReUsable({
  templateData,
  questions,
  setQuestions,
  questionBackgroundColor,
  questionsFontColor,
  listChecked,
  OpaqueDeciderForQuestionForm = () => null,
  temlateType,
  noSpace = false,
  heading = "APPLY NOW",
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [openThankYou, setOpenThankYou] = useState(false);
  const [uploadedCvURL, setUploadedCvURL] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [fileList, setFileList] = useState([]);

  const { rowNineAlignment, rowNineHeaderText, rowNineFooterText, isShowTerms,
    termsColor} = useContext(
    TemplateContext2Provider
  );

  const getQuestionAnswer = (questions) => {
    const data = [];
    questions?.forEach((item) => {
      if (item.type === 1) {
        data.push({
          questionId: item.id,
          optionId: null,
          answerText: item.answerText || "",
        });
      } else {
        const optionsData = item?.optionQuestions
          .filter((option) => option.isAnswer)
          .map((option) => ({
            questionId: item.id,
            optionId: option.id,
            answerText: option.name || "",
          }));
        data.push(...optionsData);
      }
    });
    return { applicantAnswer: data };
  };

  const onFinish = (values) => {
    let data = {
      ...values,
      templateId: templateData?.id,
      cvUrl: uploadedCvURL,
    };

    const questionsData = getQuestionAnswer(questions);
    if (questionsData) {
      data = {
        ...data,
        applicantAnswer: questionsData.applicantAnswer,
      };
    }

    const filteredData = Object.keys(data).reduce((acc, key) => {
      if (!key.includes("question_")) {
        acc[key] = data[key];
      }
      return acc;
    }, {});

    dispatch(
      templateAction.applyJob(filteredData, applyJobSuccess, applyJobFailure)
    );
  };

  const applyJobSuccess = (res) => {
    const redirectUrl = templateData?.redirectUrl;

    if (redirectUrl) {
      const fullUrl = `http://${redirectUrl}`;
      window.open(fullUrl, "_blank");
    } else {
      setOpenThankYou(true);
    }
  };

  const applyJobFailure = (res) => {
    notification.error({
      message: res?.response?.data?.message,
    });
  };
  const checkValueRequired = () => {
    const contactInfo = templateData?.contactInfo;
    const formValues = Object.keys(form.getFieldsValue()).reduce((acc, key) => {
      acc[key.trim().replace(/\s+/g, '').toLowerCase()] = form.getFieldsValue()[key];
      return acc;
    }, {});
    let isError = 0
    if (contactInfo) {
      const trueKeys = Object.keys(contactInfo).filter(key => contactInfo[key] === true);
      const selectedKeys = trueKeys.map(item => {
        const itemLower = item.trim().replace(/\s+/g, '').toLowerCase().replace(/isrequire/g, '')
        if (itemLower === 'phonenumber') {
          return 'phone';
        }
        return itemLower
      });
      for (const key of selectedKeys) {
        if (key === "email") {
          const emailValue = formValues[key];
            if (!emailValue || !/^[a-zA-Z0-9+._%+-]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(emailValue)) {
              isError++;
            }
        } else if (!formValues[key] || formValues[key].trim() === "") {
          isError++
        }
      }
    }
    return isError > 0
  }
  const handleFormValidation = () => {
    const isTermsChecked = isShowTerms ? !form.getFieldValue("termsAndConditions") : false;
    setDisabled(isTermsChecked || checkValueRequired());
  };

  return (
    <>
      <div className="question-form">
        <div
          className="question-form-content"
          style={{
            ...OpaqueDeciderForQuestionForm(),
            marginLeft: rowNineAlignment === "center" ? "auto" : rowNineAlignment === "left" ? "0" : "auto",
            marginRight: rowNineAlignment === "center" ? "auto" : rowNineAlignment === "left" ? "auto" : "0",
          }}
        >
          <div className="set-width">
            {noSpace ? (
              <div
                style={{
                  color: questionsFontColor || "black",
                  paddingBottom: "4%",
                  textAlign: "center",
                  lineHeight: "40px",
                }}
              >
                <div style={{ fontSize: "20px", fontWeight: "900" }}>
                  {rowNineHeaderText}
                </div>
              </div>
            ) : (
              <p style={{ color: questionsFontColor || "black" }}>
                {rowNineHeaderText}
              </p>
            )}
            <Form
              name="applyForm"
              form={form}
              onFinish={onFinish}
              layout="vertical"
              onValuesChange={handleFormValidation}
            >
              <PreviewInputs
                listChecked={listChecked}
                form={form}
                fileList={fileList}
                setFileList={setFileList}
                setUploadedCvURL={setUploadedCvURL}
                questionsFontColor={questionsFontColor}
                templateType={temlateType}
                noSpace={noSpace}
              />
              {questions?.map((item, index) => (
                <QuestionPreview
                  key={index}
                  type={item.type}
                  dataQuestion={item}
                  index={index}
                  questionsFontColor={questionsFontColor}
                  questions={questions}
                  setQuestions={setQuestions}
                />
              ))}
              {templateData.formTerm && isShowTerms && (
                <Form.Item
                  name="termsAndConditions"
                  valuePropName="checked"
                  style={{ textAlign: "left", textShadow: `0 0 0 ${questionsFontColor}` }}
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(new Error("You must accept the terms and conditions")),
                    },
                  ]}
                >
                  <div style={{ color: termsColor || "black", marginTop: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label style={{ display: "flex", alignItems: "flex-start", color: termsColor }}>
                        <input
                          type="checkbox"
                          style={{ marginRight: "8px", marginTop: "6px" }}
                          onChange={(e) => {
                            form.setFieldsValue({ termsAndConditions: e.target.checked });
                            form.validateFields(["termsAndConditions"]);
                            setDisabled(e.target.checked);
                          }}
                        />
                        <span style={{ color: termsColor || "black" }}>
                          {templateData.formTermTextWithoutUrl}{" "}
                          {templateData.formTermUrl && (
                            <a href={templateData.formTermUrl} style={{ color: termsColor || "black" }} target="_blank" rel="noopener noreferrer">
                              {templateData.formTermText}
                            </a>
                          )}
                          {templateData.formPrivacyUrl && (
                              <>,{" "}
                                <a href={templateData.formPrivacyUrl} style={{ color: termsColor || "black" }} target="_blank" rel="noopener noreferrer">
                                  {templateData.formPrivacyText}
                                </a>
                              </>
                          )}
                          {templateData.formTermAfterTextWithoutUrl}
                        </span>
                      </label>
                    </div>
                  </div>
                </Form.Item>
              )}
              
              <Form.Item>
                <div className="apply-preview">
                  <Button
                    style={{
                      ...(temlateType === 2
                        ? {
                            background: questionsFontColor,
                            color: questionBackgroundColor,
                            border: "none",
                            height: "40px",
                          }
                        : {}),
                      ...(!disabled
                        ? {}
                        : {
                            background: "#d9d9d9", // Disabled background color
                            color: "#a0a0a0", // Disabled text color
                            cursor: "not-allowed",
                          }),
                    }}
                    disabled={disabled}
                    type="submit"
                    onClick={() => form.submit()}
                  >
                    {heading}
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <Thankyou
        form={form}
        openThankYou={openThankYou}
        setOpenThankYou={setOpenThankYou}
        setFileList={setFileList}
        setUploadedCvURL={setUploadedCvURL}
        thankyouContent={templateData.thankyouContent}
      />
    </>
  );
}
